var exports = {
  "MK": "x43aef4ae--257c34--menu",
  "wm": "x43aef4ae--257c34--logo",
  "Lg": "x43aef4ae--257c34--navigation",
  "nf": "x43aef4ae--257c34--link",
  "M3": "x43aef4ae--257c34--contacts",
};

module.exports = exports;
